import img1 from "../../assets/about-model-1.jpg";
import img2 from "../../assets/about-model-2.jpg";

function AboutMain() {
    return ( 
        <>
            <section className="about-main">
                <div className="container">
                    <div className="row">
                        <div className="col-12 co-md-12 col-lg-6">
                            <h1 className="main-header">
                                We are here to empower OnlyFans content creators for success
                            </h1>
                            <p className="description">
                                <span className="color">We are an international management agency</span> for content creators, specializing in platforms like OnlyFans. Our team of over 60 dedicated professionals is spread across the globe, with active teams in Europe and USA.
                                <br /><br />
                                Engaged in <span className="color">marketing, promotion, sales, video editing, scriptwriting, and various other tasks,</span> we are committed to driving exceptional performance on these platforms for our creators worldwide.
                            </p>
                            <a href="/contacts">
                                <button className="main-button">
                                        Join now
                                </button>
                            </a>
                        </div>
                        <div className="col-12 co-md-12 col-lg-6 row-images">
                            <div className="image-wrapper">
                                <img src={img2} alt="" />
                            </div>
                            <div className="image-wrapper">
                                <img src={img1} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
     );
}

export default AboutMain;